var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 body-1"},[_vm._v(" Pedido mínimo: "+_vm._s(_vm.oferta.quantidade)+" "+_vm._s(_vm.oferta.unidadeMedida.descricao)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }